import React, { useContext, useEffect, useState } from "react";
import successIcon from "../../images/successGreenIcon.png";
import errorIcon from "../../images/errorRedIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { ListDetailsContext } from "../../contexts/ListDetailsContext";
import { UrlContext } from "../../contexts/UrlContext";

export default function ExEmailChange({
  email,
  expert_id,
  exObject,
  setExObject,
}) {
  const { tableData, setTableData } = useContext(ListDetailsContext);
  const [exEmail, setExEmail] = useState("");
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { API_URL } = useContext(UrlContext);
  useEffect(() => {
    if (email === "None") return;
    setExEmail(email);
  }, [email]);

  const changeEmail = (newValue) => {
    setReturnError(false);
    setLoading(true);
    const url = `${API_URL}change-email`;
    const data = {
      expert_id,
      email: newValue,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setExObject({
            ...exObject,
            expertEmail: newValue,
          });
          setReturnSuccess(true);
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
          setTableData(
            tableData.map((item) => {
              if (item.expert.ID === expert_id) {
                item.expert.email = newValue;
              }
              return item;
            })
          );
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        console.log(err);
      });
  };

  return (
    <>
      <input
        placeholder="Email"
        value={exEmail}
        onChange={(e) => setExEmail(e.target.value)}
        onBlur={(e) => changeEmail(e.target.value)}
      />
      {loading && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}
      {returnSuccess && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={errorIcon}
          alt="error"
          title="Error! Please reload"
        />
      )}
    </>
  );
}
